import axios from "axios";
import { backendUrl, errorSweetAlert } from "../helpers/constants";
import store from "../redux/store";
import { logout } from "../redux/slices/authSlice";

const axiosConfig = axios.create({
  baseURL: backendUrl,
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 60000,
});

function isFormDataBody(data) {
  return typeof FormData !== "undefined" && data instanceof FormData;
}

function setHeader(headers, name, value) {
  if (!headers) return;
  if (typeof headers.set === "function") {
    headers.set(name, value);
    return;
  }
  headers[name] = value;
}

function clearContentType(headers) {
  if (!headers) return;
  if (typeof headers.set === "function") {
    headers.set("Content-Type", false);
  }
  if (typeof headers.delete === "function") {
    headers.delete("Content-Type");
    headers.delete("content-type");
  }
  delete headers["Content-Type"];
  delete headers["content-type"];
  if (headers.common) {
    delete headers.common["Content-Type"];
    delete headers.common["content-type"];
  }
  if (headers.post) {
    delete headers.post["Content-Type"];
    delete headers.post["content-type"];
  }
}

axiosConfig.interceptors.request.use(
  (config) => {
    const { token } = store.getState().auth;

    config.headers = config.headers || {};
    setHeader(config.headers, "Authorization", `Bearer ${token || ""}`);

    if (isFormDataBody(config.data)) {
      // Browser must set multipart boundary
      clearContentType(config.headers);
      config.transformRequest = [(data) => data];
    } else if (config.data != null && typeof config.data === "object") {
      // Always JSON for plain objects — never leave axios on urlencoded
      setHeader(config.headers, "Content-Type", "application/json");
      if (typeof config.data !== "string") {
        config.data = JSON.stringify(config.data);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const notAuthorizedMessages = [
  "Access denied, you're not login",
  "Access denied, user not found",
  "Access denied, invalid token",
  "Role not found for the user",
  "User doesn't have permission to this route",
  "User not found",
  "Authentication token missing",
  "Invalid or expired token",
];

axiosConfig.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      if (
        notAuthorizedMessages.includes(
          error.response?.data?.message?.message ||
            error.response?.data?.message
        )
      ) {
        store.dispatch(logout());
        errorSweetAlert("Session expired. Please login again.");
        setTimeout(() => {
          window.location.href = "/";
        }, [500]);
      }
    } else if (error.request) {
      console.error("Request error:", error.request);
    } else {
      console.error("Error:", error.message);
    }
    return Promise.reject({
      ...error,
      response: {
        ...error?.response,
        data: {
          ...error.response?.data,
          message: error?.response?.data?.message?.message
            ? error?.response?.data?.message?.message
            : error?.response?.data?.message ||
              "Server error: please contact system admin",
        },
      },
    });
  }
);

export default axiosConfig;
